import React from "react";
import MenuList from "./MenuList";
import SvgCompactDoubleArrowIcon from '../../../svg/SvgCompactDoubleArrowIcon';
import { Link } from "react-router-dom";

export default function MenuItem({item, onToggleChildren}) {
  //const { path, url } = useRouteMatch()
  //console.log("MenuItem: path=", path, " url=", url);

  //console.log("----- item=", item);

  const hasChildren = item?.children && item.children.length > 0
  console.log("hasChildren=" + hasChildren);
  const isFolder = "children" in item && Array.isArray(item.children)


  function onToggleChildrenWrap()
  {
    //console.log("MenuItem: Inside onToggleChildrenWrap: item=", item )
    onToggleChildren(item)
  }

  // If the item has children, clicking it will toggle the display of children
  //Otherwise, it will call the onItemSelection function so that the parent component can handle the selection
  //const handleItemClick = hasChildren ? onToggleChildren : () => {onItemSelection(item)};
  const handleItemClick = (e) => { 
    e.stopPropagation();
    if (hasChildren) {
      onToggleChildrenWrap();
    }
  }

  let itemElements = []
  if (isFolder) {
    itemElements.push(<span>{item.name}</span>)
    itemElements.push(
      //Add arrow icon to indicate that folder is expandable
      <SvgCompactDoubleArrowIcon height="0.5em" />
    )
  } else {
    itemElements.push(
      <Link to={`/support/db/query/${item.id}/form`}
      className="menu-item-link"
    >
      {item.name}
    </Link>
    )
  }

  /* CSS class menu-item-expanded rotates the arrow icon 180 degrees to indicate that the currently expanded items can be collapse */
  return (
    <li onClick={handleItemClick}>
      <div 
        className={
          item?.displayChildren ? "menu-item menu-item--expanded" :
        "menu-item"
      }>
        {itemElements}
      </div>

      {
        hasChildren && item?.displayChildren && 
          <MenuList itemList={item.children} onToggleChildren={onToggleChildren} />
      }
    </li>
  );
}
  
